function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o);
}
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"])
    return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r))
    return _arrayLikeToArray(r); }
function _regeneratorValues(e) { if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0;
    if (t)
        return t.call(e);
    if ("function" == typeof e.next)
        return e;
    if (!isNaN(e.length))
        return { next: function next() { return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e }; } };
} throw new TypeError(_typeof(e) + " is not iterable"); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var _n = 0, F = function F() { };
        return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
} var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try {
        a || null == t["return"] || t["return"]();
    }
    finally {
        if (u)
            throw o;
    } } }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
    var o, i = p[t], d = G.p, l = i[2];
    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
} if (o || r > 1)
    return a; throw y = !0, n; } return function (o, p, l) { if (f > 1)
    throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
    try {
        if (f = 2, i) {
            if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u)))
                    throw TypeError("iterator result is not an object");
                if (!t.done)
                    return t;
                u = t.value, c < 2 && (c = 0);
            }
            else
                1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
            i = e;
        }
        else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
            break;
    }
    catch (t) {
        i = e, c = 1, u = t;
    }
    finally {
        f = 1;
    }
} return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() { } function GeneratorFunction() { } function GeneratorFunctionPrototype() { } t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try {
    i({}, "", {});
}
catch (e) {
    i = 0;
} _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r)
    i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;
else {
    var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); };
    o("next", 0), o("throw", 1), o("return", 2);
} }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try {
    var i = n[a](c), u = i.value;
}
catch (n) {
    return void e(n);
} i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, FormControl, InputLabel, Select, MenuItem, Alert, Checkbox, CircularProgress, Stack } from '@mui/material';
import { Add as AddIcon, ListAltOutlined as EditIcon, DeleteOutlined as DeleteIcon, ExpandMore as ExpandMoreIcon, FilterListOutlined as FilterIcon } from '@mui/icons-material';
import PolicyModal from '../components/PolicyModal';
import { ConfirmationDialog } from '../components/ConfirmationDialog';
import { UserAPI } from '../apis/UserAPI';
import { isAuthorized } from '../utils/utilities';
// Extended interface for UI state management
var PolicyManagement = function PolicyManagement() {
    var _useState = useState([]), _useState2 = _slicedToArray(_useState, 2), policies = _useState2[0], setPolicies = _useState2[1];
    var _useState3 = useState([]), _useState4 = _slicedToArray(_useState3, 2), applications = _useState4[0], setApplications = _useState4[1];
    var _useState5 = useState(''), _useState6 = _slicedToArray(_useState5, 2), selectedApplication = _useState6[0], setSelectedApplication = _useState6[1];
    var _useState7 = useState(true), _useState8 = _slicedToArray(_useState7, 2), dataLoading = _useState8[0], setDataLoading = _useState8[1];
    var _useState9 = useState(null), _useState0 = _slicedToArray(_useState9, 2), error = _useState0[0], setError = _useState0[1];
    // Modal and dialog state
    var _useState1 = useState(false), _useState10 = _slicedToArray(_useState1, 2), policyModalOpen = _useState10[0], setPolicyModalOpen = _useState10[1];
    var _useState11 = useState(null), _useState12 = _slicedToArray(_useState11, 2), selectedPolicy = _useState12[0], setSelectedPolicy = _useState12[1];
    var _useState13 = useState(false), _useState14 = _slicedToArray(_useState13, 2), deleteDialogOpen = _useState14[0], setDeleteDialogOpen = _useState14[1];
    var _useState15 = useState(null), _useState16 = _slicedToArray(_useState15, 2), policyToDelete = _useState16[0], setPolicyToDelete = _useState16[1];
    var _useState17 = useState(false), _useState18 = _slicedToArray(_useState17, 2), bulkDeleteDialogOpen = _useState18[0], setBulkDeleteDialogOpen = _useState18[1];
    var _useState19 = useState(false), _useState20 = _slicedToArray(_useState19, 2), loading = _useState20[0], setLoading = _useState20[1];
    var _useState21 = useState(''), _useState22 = _slicedToArray(_useState21, 2), successMessage = _useState22[0], setSuccessMessage = _useState22[1];
    var _useState23 = useState({}), _useState24 = _slicedToArray(_useState23, 2), expandedSpecs = _useState24[0], setExpandedSpecs = _useState24[1];
    var _useState25 = useState([]), _useState26 = _slicedToArray(_useState25, 2), selectedPolicies = _useState26[0], setSelectedPolicies = _useState26[1];
    var _useState27 = useState(false), _useState28 = _slicedToArray(_useState27, 2), selectAllChecked = _useState28[0], setSelectAllChecked = _useState28[1];
    // Load data on component mount
    useEffect(function () {
        loadInitialData();
    }, []);
    var loadInitialData = /*#__PURE__*/ function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee() {
            var _yield$Promise$all, _yield$Promise$all2, policiesResponse, applicationsResponse, transformedPolicies, _t;
            return _regenerator().w(function (_context) {
                while (1)
                    switch (_context.p = _context.n) {
                        case 0:
                            setDataLoading(true);
                            setError(null);
                            _context.p = 1;
                            _context.n = 2;
                            return Promise.all([UserAPI.getPolicies(), UserAPI.getApplications()]);
                        case 2:
                            _yield$Promise$all = _context.v;
                            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
                            policiesResponse = _yield$Promise$all2[0];
                            applicationsResponse = _yield$Promise$all2[1];
                            // Transform API policies to component format
                            transformedPolicies = policiesResponse.resource.map(function (policy) {
                                var _policy$metadata;
                                return _objectSpread(_objectSpread({}, policy), {}, {
                                    displayId: policy.id.toString(),
                                    // Use id as displayId for UI purposes
                                    specification: JSON.stringify({
                                        resourceType: policy.resourceType,
                                        id: policy.id,
                                        application_id: policy.application_id,
                                        name: policy.name,
                                        effect: policy.effect,
                                        resource_action: policy.resource_action
                                    }, null, 2),
                                    dateAdded: (_policy$metadata = policy.metadata) !== null && _policy$metadata !== void 0 && _policy$metadata.createdDate ? new Date(policy.metadata.createdDate).toLocaleDateString('en-US', {
                                        month: 'short',
                                        day: 'numeric',
                                        year: 'numeric'
                                    }) : 'Unknown'
                                });
                            });
                            setPolicies(transformedPolicies);
                            setApplications(applicationsResponse.resource);
                            // Set default application filter to first application if available
                            if (applicationsResponse.resource.length > 0) {
                                setSelectedApplication(applicationsResponse.resource[0].name);
                            }
                            _context.n = 4;
                            break;
                        case 3:
                            _context.p = 3;
                            _t = _context.v;
                            console.error('Failed to load data:', _t);
                            setError('Failed to load policies and applications. Please try again.');
                        case 4:
                            _context.p = 4;
                            setDataLoading(false);
                            return _context.f(4);
                        case 5:
                            return _context.a(2);
                    }
            }, _callee, null, [[1, 3, 4, 5]]);
        }));
        return function loadInitialData() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleAddPolicy = function handleAddPolicy() {
        setSelectedPolicy(null);
        setPolicyModalOpen(true);
    };
    var handleEditPolicy = function handleEditPolicy(policy) {
        setSelectedPolicy(policy);
        setPolicyModalOpen(true);
    };
    var handleDeletePolicy = function handleDeletePolicy(policy) {
        setPolicyToDelete(policy);
        setDeleteDialogOpen(true);
    };
    // Convert PolicyWithId to Policy for modal compatibility
    var convertToModalPolicy = function convertToModalPolicy(policy) {
        if (!policy)
            return null;
        return {
            id: policy.displayId,
            name: policy.name,
            resourceType: policy.resourceType,
            effect: policy.effect,
            resource_action: policy.resource_action,
            specification: policy.specification || '',
            dateAdded: policy.dateAdded,
            application_id: policy.application_id
        };
    };
    var handleSavePolicy = /*#__PURE__*/ function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee2(policyData) {
            var selectedApp, createRequest, _t2;
            return _regenerator().w(function (_context2) {
                while (1)
                    switch (_context2.p = _context2.n) {
                        case 0:
                            setLoading(true);
                            setError(null);
                            _context2.p = 1;
                            if (!selectedPolicy) {
                                _context2.n = 4;
                                break;
                            }
                            _context2.n = 2;
                            return UserAPI.updatePolicy(selectedPolicy.id.toString(), {
                                organization_id: selectedPolicy.organization_id,
                                application_id: selectedPolicy.application_id,
                                name: policyData.name,
                                effect: policyData.effect,
                                resource_action: policyData.resource_action
                            });
                        case 2:
                            _context2.n = 3;
                            return loadInitialData();
                        case 3:
                            setSuccessMessage('Policy updated successfully');
                            _context2.n = 8;
                            break;
                        case 4:
                            // Get application_id from selected application
                            selectedApp = applications.find(function (app) {
                                return app.name === selectedApplication;
                            });
                            if (selectedApp) {
                                _context2.n = 5;
                                break;
                            }
                            setError('Please select an application before creating a policy.');
                            return _context2.a(2);
                        case 5:
                            // Add new policy
                            createRequest = {
                                organization_id: selectedApp.organization_id,
                                application_id: [selectedApp.id],
                                name: policyData.name,
                                effect: policyData.effect,
                                resource_action: policyData.resource_action
                            };
                            _context2.n = 6;
                            return UserAPI.createPolicy(createRequest);
                        case 6:
                            _context2.n = 7;
                            return loadInitialData();
                        case 7:
                            setSuccessMessage('Policy added successfully');
                        case 8:
                            setPolicyModalOpen(false);
                            setSelectedPolicy(null);
                            _context2.n = 10;
                            break;
                        case 9:
                            _context2.p = 9;
                            _t2 = _context2.v;
                            console.error('Error saving policy:', _t2);
                            setError('Failed to save policy. Please try again.');
                        case 10:
                            _context2.p = 10;
                            setLoading(false);
                            return _context2.f(10);
                        case 11:
                            return _context2.a(2);
                    }
            }, _callee2, null, [[1, 9, 10, 11]]);
        }));
        return function handleSavePolicy(_x) {
            return _ref2.apply(this, arguments);
        };
    }();
    var confirmDeletePolicy = /*#__PURE__*/ function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee3() {
            var rolePolicyRecords, _iterator, _step, record, _t3, _t4;
            return _regenerator().w(function (_context3) {
                while (1)
                    switch (_context3.p = _context3.n) {
                        case 0:
                            if (!policyToDelete) {
                                _context3.n = 13;
                                break;
                            }
                            setLoading(true);
                            setError(null);
                            _context3.p = 1;
                            _context3.n = 2;
                            return UserAPI.getPolicyRoleRecords(policyToDelete.id.toString());
                        case 2:
                            rolePolicyRecords = _context3.v;
                            if (!(rolePolicyRecords.length > 0)) {
                                _context3.n = 9;
                                break;
                            }
                            console.log("Cleaning up ".concat(rolePolicyRecords.length, " role-policy mappings for policy ").concat(policyToDelete.name));
                            _iterator = _createForOfIteratorHelper(rolePolicyRecords);
                            _context3.p = 3;
                            _iterator.s();
                        case 4:
                            if ((_step = _iterator.n()).done) {
                                _context3.n = 6;
                                break;
                            }
                            record = _step.value;
                            _context3.n = 5;
                            return UserAPI.deleteRolePolicyById(record.rolepolicy_id);
                        case 5:
                            _context3.n = 4;
                            break;
                        case 6:
                            _context3.n = 8;
                            break;
                        case 7:
                            _context3.p = 7;
                            _t3 = _context3.v;
                            _iterator.e(_t3);
                        case 8:
                            _context3.p = 8;
                            _iterator.f();
                            return _context3.f(8);
                        case 9:
                            _context3.n = 10;
                            return UserAPI.deletePolicy(policyToDelete.id.toString());
                        case 10:
                            setPolicies(function (prevPolicies) {
                                return prevPolicies.filter(function (p) {
                                    return p.id !== policyToDelete.id;
                                });
                            });
                            // Clear the deleted policy from selection if it was selected
                            setSelectedPolicies(function (prev) {
                                return prev.filter(function (id) {
                                    return id !== policyToDelete.displayId;
                                });
                            });
                            setSelectAllChecked(false);
                            setSuccessMessage('Policy deleted successfully');
                            setDeleteDialogOpen(false);
                            setPolicyToDelete(null);
                            _context3.n = 12;
                            break;
                        case 11:
                            _context3.p = 11;
                            _t4 = _context3.v;
                            console.error('Error deleting policy:', _t4);
                            setError('Failed to delete policy. Please try again.');
                        case 12:
                            _context3.p = 12;
                            setLoading(false);
                            return _context3.f(12);
                        case 13:
                            return _context3.a(2);
                    }
            }, _callee3, null, [[3, 7, 8, 9], [1, 11, 12, 13]]);
        }));
        return function confirmDeletePolicy() {
            return _ref3.apply(this, arguments);
        };
    }();
    var handleBulkDelete = function handleBulkDelete() {
        setBulkDeleteDialogOpen(true);
    };
    var confirmBulkDelete = /*#__PURE__*/ function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee4() {
            var successCount, errorCount, _iterator2, _step2, _loop, _t7, _t8;
            return _regenerator().w(function (_context5) {
                while (1)
                    switch (_context5.p = _context5.n) {
                        case 0:
                            if (!(selectedPolicies.length === 0)) {
                                _context5.n = 1;
                                break;
                            }
                            return _context5.a(2);
                        case 1:
                            setLoading(true);
                            setError(null);
                            successCount = 0;
                            errorCount = 0;
                            _context5.p = 2;
                            // Process each selected policy
                            _iterator2 = _createForOfIteratorHelper(selectedPolicies);
                            _context5.p = 3;
                            _loop = /*#__PURE__*/ _regenerator().m(function _loop() {
                                var policyId, _policyToDelete, rolePolicyRecords, _iterator3, _step3, record, _t5, _t6;
                                return _regenerator().w(function (_context4) {
                                    while (1)
                                        switch (_context4.p = _context4.n) {
                                            case 0:
                                                policyId = _step2.value;
                                                _context4.p = 1;
                                                _policyToDelete = policies.find(function (p) {
                                                    return p.displayId === policyId;
                                                });
                                                if (_policyToDelete) {
                                                    _context4.n = 2;
                                                    break;
                                                }
                                                return _context4.a(2, 1);
                                            case 2:
                                                _context4.n = 3;
                                                return UserAPI.getPolicyRoleRecords(_policyToDelete.id.toString());
                                            case 3:
                                                rolePolicyRecords = _context4.v;
                                                if (!(rolePolicyRecords.length > 0)) {
                                                    _context4.n = 10;
                                                    break;
                                                }
                                                _iterator3 = _createForOfIteratorHelper(rolePolicyRecords);
                                                _context4.p = 4;
                                                _iterator3.s();
                                            case 5:
                                                if ((_step3 = _iterator3.n()).done) {
                                                    _context4.n = 7;
                                                    break;
                                                }
                                                record = _step3.value;
                                                _context4.n = 6;
                                                return UserAPI.deleteRolePolicyById(record.rolepolicy_id);
                                            case 6:
                                                _context4.n = 5;
                                                break;
                                            case 7:
                                                _context4.n = 9;
                                                break;
                                            case 8:
                                                _context4.p = 8;
                                                _t5 = _context4.v;
                                                _iterator3.e(_t5);
                                            case 9:
                                                _context4.p = 9;
                                                _iterator3.f();
                                                return _context4.f(9);
                                            case 10:
                                                _context4.n = 11;
                                                return UserAPI.deletePolicy(_policyToDelete.id.toString());
                                            case 11:
                                                successCount++;
                                                _context4.n = 13;
                                                break;
                                            case 12:
                                                _context4.p = 12;
                                                _t6 = _context4.v;
                                                console.error("Error deleting policy ".concat(policyId, ":"), _t6);
                                                errorCount++;
                                            case 13:
                                                return _context4.a(2);
                                        }
                                }, _loop, null, [[4, 8, 9, 10], [1, 12]]);
                            });
                            _iterator2.s();
                        case 4:
                            if ((_step2 = _iterator2.n()).done) {
                                _context5.n = 7;
                                break;
                            }
                            return _context5.d(_regeneratorValues(_loop()), 5);
                        case 5:
                            if (!_context5.v) {
                                _context5.n = 6;
                                break;
                            }
                            return _context5.a(3, 6);
                        case 6:
                            _context5.n = 4;
                            break;
                        case 7:
                            _context5.n = 9;
                            break;
                        case 8:
                            _context5.p = 8;
                            _t7 = _context5.v;
                            _iterator2.e(_t7);
                        case 9:
                            _context5.p = 9;
                            _iterator2.f();
                            return _context5.f(9);
                        case 10:
                            // Update local state - remove successfully deleted policies
                            setPolicies(function (prevPolicies) {
                                return prevPolicies.filter(function (p) {
                                    return p.displayId && !selectedPolicies.includes(p.displayId);
                                });
                            });
                            // Clear selections
                            setSelectedPolicies([]);
                            setSelectAllChecked(false);
                            // Set success message
                            if (successCount > 0) {
                                setSuccessMessage("".concat(successCount, " ").concat(successCount === 1 ? 'policy' : 'policies', " deleted successfully").concat(errorCount > 0 ? ". ".concat(errorCount, " failed to delete.") : ''));
                            }
                            if (errorCount > 0 && successCount === 0) {
                                setError('Failed to delete selected policies. Please try again.');
                            }
                            setBulkDeleteDialogOpen(false);
                            _context5.n = 12;
                            break;
                        case 11:
                            _context5.p = 11;
                            _t8 = _context5.v;
                            console.error('Error during bulk delete:', _t8);
                            setError('Failed to delete policies. Please try again.');
                        case 12:
                            _context5.p = 12;
                            setLoading(false);
                            return _context5.f(12);
                        case 13:
                            return _context5.a(2);
                    }
            }, _callee4, null, [[3, 8, 9, 10], [2, 11, 12, 13]]);
        }));
        return function confirmBulkDelete() {
            return _ref4.apply(this, arguments);
        };
    }();
    var toggleSpecificationExpansion = function toggleSpecificationExpansion(policyId) {
        setExpandedSpecs(function (prev) {
            return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, policyId, !prev[policyId]));
        });
    };
    var handleSelectAll = function handleSelectAll(checked) {
        setSelectAllChecked(checked);
        var updatedSelectedPolicies = checked ? policies.map(function (p) {
            return p.displayId;
        }).filter(function (id) {
            return id !== undefined;
        }) : [];
        setSelectedPolicies(updatedSelectedPolicies);
    };
    var handleSelectPolicy = function handleSelectPolicy(policyId, checked) {
        var updatedSelectedPolicies = checked ? [].concat(_toConsumableArray(selectedPolicies), [policyId]) : selectedPolicies.filter(function (id) {
            return id !== policyId;
        });
        setSelectedPolicies(updatedSelectedPolicies);
        if (!checked) {
            setSelectAllChecked(false);
        }
    };
    // Check view permission
    if (!isAuthorized('RBAC:ViewPolicy')) {
        return /*#__PURE__*/ React.createElement(Box, {
            sx: {
                p: 3,
                bgcolor: '#f8f8f8'
            }
        }, /*#__PURE__*/ React.createElement(Box, {
            sx: {
                textAlign: 'center',
                py: 8
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h6",
            color: "#666",
            gutterBottom: true
        }, "Access Denied"), /*#__PURE__*/ React.createElement(Typography, {
            variant: "body1",
            color: "#888"
        }, "You don't have permission to view policy management settings.")));
    }
    return /*#__PURE__*/ React.createElement(Box, {
        sx: {
            p: 3,
            bgcolor: '#f8f8f8'
        }
    }, /*#__PURE__*/ React.createElement(Paper, {
        sx: {
            p: 3,
            borderRadius: 2,
            boxShadow: 'none'
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 3
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        sx: {
            mb: 3
        }
    }, "Define policies and specify the details of each in JSON format."), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            gap: 1,
            alignItems: 'center'
        }
    }, selectedPolicies.length > 0 && isAuthorized('RBAC:DeletePolicy') && /*#__PURE__*/ React.createElement(Button, {
        variant: "outlined",
        onClick: handleBulkDelete,
        sx: {
            color: '#DA291C',
            border: '1px solid #DA291C',
            backgroundColor: 'transparent',
            boxShadow: 'none',
            textTransform: 'none',
            minWidth: '44px',
            width: '44px',
            height: '44px'
        }
    }, /*#__PURE__*/ React.createElement(DeleteIcon, null)), /*#__PURE__*/ React.createElement(FormControl, {
        size: "small",
        sx: {
            minWidth: 200
        }
    }, /*#__PURE__*/ React.createElement(InputLabel, null, "Application"), /*#__PURE__*/ React.createElement(Select, {
        value: selectedApplication,
        onChange: function onChange(e) {
            return setSelectedApplication(e.target.value);
        },
        label: "Application",
        disabled: dataLoading
    }, applications.map(function (app) {
        return /*#__PURE__*/ React.createElement(MenuItem, {
            key: app.id || app.name,
            value: app.name
        }, app.name);
    }))), isAuthorized('RBAC:CreatePolicy') && /*#__PURE__*/ React.createElement(Button, {
        variant: "contained",
        startIcon: /*#__PURE__*/ React.createElement(AddIcon, null),
        onClick: handleAddPolicy,
        sx: {
            textTransform: 'none',
            boxShadow: 'none'
        }
    }, "Policy"))), dataLoading && /*#__PURE__*/ React.createElement(Box, {
        sx: {
            textAlign: 'center',
            py: 4
        }
    }, /*#__PURE__*/ React.createElement(CircularProgress, null), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            mt: 2
        }
    }, "Loading policies and applications...")), error && /*#__PURE__*/ React.createElement(Alert, {
        severity: "error",
        sx: {
            mb: 3
        }
    }, error), successMessage && /*#__PURE__*/ React.createElement(Alert, {
        severity: "success",
        sx: {
            mb: 3
        },
        onClose: function onClose() {
            return setSuccessMessage('');
        }
    }, successMessage), !dataLoading && !error && /*#__PURE__*/ React.createElement(TableContainer, null, /*#__PURE__*/ React.createElement(Table, null, /*#__PURE__*/ React.createElement(TableHead, null, /*#__PURE__*/ React.createElement(TableRow, null, /*#__PURE__*/ React.createElement(TableCell, {
        sx: {
            color: '#212121',
            borderBottom: '1px solid #ebebeb',
            width: '60px',
            px: 2
        }
    }, /*#__PURE__*/ React.createElement(Checkbox, {
        checked: selectAllChecked,
        onChange: function onChange(e) {
            return handleSelectAll(e.target.checked);
        },
        sx: {
            color: '#d9d9d9',
            '&.Mui-checked': {
                color: '#26890d'
            }
        }
    })), /*#__PURE__*/ React.createElement(TableCell, {
        sx: {
            color: '#212121',
            borderBottom: '1px solid #ebebeb',
            width: '270px'
        }
    }, /*#__PURE__*/ React.createElement(Stack, {
        direction: "row",
        alignItems: "center",
        gap: 1
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            fontWeight: 600
        }
    }, "Name"), /*#__PURE__*/ React.createElement(FilterIcon, {
        sx: {
            fontSize: 18,
            color: '#26890d'
        }
    }))), /*#__PURE__*/ React.createElement(TableCell, {
        sx: {
            color: '#212121',
            borderBottom: '1px solid #ebebeb'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            fontWeight: 600
        }
    }, "Specification")), /*#__PURE__*/ React.createElement(TableCell, {
        sx: {
            color: '#212121',
            borderBottom: '1px solid #ebebeb',
            width: '200px'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            fontWeight: 600
        }
    }, "Actions")))), /*#__PURE__*/ React.createElement(TableBody, null, function () {
        var filteredPolicies = policies.filter(function (policy) {
            if (!selectedApplication)
                return true;
            // Find the application by name to get its ID
            var selectedApp = applications.find(function (app) {
                return app.name === selectedApplication;
            });
            if (!selectedApp)
                return false;
            // Check if the policy's application_id matches (converting app ID to string)
            if (Array.isArray(policy.application_id)) {
                return policy.application_id.includes(selectedApp.id.toString());
            }
            else {
                return policy.application_id === selectedApp.id.toString();
            }
        });
        if (filteredPolicies.length === 0) {
            return /*#__PURE__*/ React.createElement(TableRow, null, /*#__PURE__*/ React.createElement(TableCell, {
                colSpan: 4,
                sx: {
                    textAlign: 'center',
                    py: 4
                }
            }, /*#__PURE__*/ React.createElement(Typography, {
                variant: "body2",
                color: "text.secondary"
            }, "No policies found")));
        }
        return filteredPolicies.map(function (policy) {
            return /*#__PURE__*/ React.createElement(TableRow, {
                key: policy.id
            }, /*#__PURE__*/ React.createElement(TableCell, {
                sx: {
                    borderBottom: '1px solid #ebebeb',
                    py: 2,
                    px: 2
                }
            }, /*#__PURE__*/ React.createElement(Checkbox, {
                checked: policy.displayId ? selectedPolicies.includes(policy.displayId) : false,
                onChange: function onChange(e) {
                    if (policy.displayId) {
                        handleSelectPolicy(policy.displayId, e.target.checked);
                    }
                },
                sx: {
                    color: '#d9d9d9',
                    '&.Mui-checked': {
                        color: '#26890d'
                    }
                }
            })), /*#__PURE__*/ React.createElement(TableCell, {
                sx: {
                    borderBottom: '1px solid #ebebeb',
                    py: 2
                }
            }, /*#__PURE__*/ React.createElement(Typography, {
                variant: "body1",
                sx: {
                    fontWeight: 600,
                    color: isAuthorized('RBAC:UpdatePolicy') ? '#26890d' : '#212121',
                    textDecoration: isAuthorized('RBAC:UpdatePolicy') ? 'underline' : 'none',
                    cursor: isAuthorized('RBAC:UpdatePolicy') ? 'pointer' : 'default',
                    '&:hover': isAuthorized('RBAC:UpdatePolicy') ? {
                        color: '#1f6b0a'
                    } : {}
                },
                onClick: isAuthorized('RBAC:UpdatePolicy') ? function () {
                    return handleEditPolicy(policy);
                } : undefined
            }, policy.name)), /*#__PURE__*/ React.createElement(TableCell, {
                sx: {
                    borderBottom: '1px solid #ebebeb',
                    py: 2,
                    maxWidth: '500px',
                    minWidth: '300px'
                }
            }, /*#__PURE__*/ React.createElement(Box, {
                sx: {
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: 1
                }
            }, /*#__PURE__*/ React.createElement(Box, {
                component: "pre",
                sx: _objectSpread(_objectSpread({
                    fontFamily: 'Consolas, Monaco, monospace',
                    fontSize: '13px',
                    lineHeight: '20px',
                    color: '#212121',
                    backgroundColor: '#f8f9fa',
                    padding: '12px 16px',
                    borderRadius: 2,
                    border: '1px solid #e0e0e0',
                    margin: 0,
                    overflow: 'hidden',
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word',
                    display: '-webkit-box',
                    WebkitLineClamp: policy.displayId && expandedSpecs[policy.displayId] ? 6 : 2,
                    WebkitBoxOrient: 'vertical',
                    textOverflow: 'ellipsis',
                    flex: 1,
                    minHeight: policy.displayId && expandedSpecs[policy.displayId] ? '120px' : '40px'
                }, policy.displayId && expandedSpecs[policy.displayId] && {
                    overflowY: 'auto',
                    maxHeight: '120px'
                }), {}, {
                    '&::-webkit-scrollbar': {
                        width: '6px'
                    },
                    '&::-webkit-scrollbar-track': {
                        backgroundColor: '#f1f1f1',
                        borderRadius: '3px'
                    },
                    '&::-webkit-scrollbar-thumb': {
                        backgroundColor: '#c1c1c1',
                        borderRadius: '3px',
                        '&:hover': {
                            backgroundColor: '#a8a8a8'
                        }
                    }
                })
            }, policy.specification), /*#__PURE__*/ React.createElement(IconButton, {
                onClick: function onClick() {
                    if (policy.displayId) {
                        toggleSpecificationExpansion(policy.displayId);
                    }
                },
                sx: {
                    padding: '6px',
                    color: '#595959',
                    alignSelf: 'center',
                    '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)',
                        color: '#26890d'
                    }
                }
            }, /*#__PURE__*/ React.createElement(ExpandMoreIcon, {
                sx: {
                    fontSize: '20px',
                    transform: policy.displayId && expandedSpecs[policy.displayId] ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.2s ease'
                }
            })))), /*#__PURE__*/ React.createElement(TableCell, {
                sx: {
                    borderBottom: '1px solid #ebebeb',
                    py: 2
                }
            }, /*#__PURE__*/ React.createElement(Box, {
                sx: {
                    display: 'flex',
                    gap: 1
                }
            }, isAuthorized('RBAC:UpdatePolicy') && /*#__PURE__*/ React.createElement(IconButton, {
                onClick: function onClick() {
                    return handleEditPolicy(policy);
                },
                sx: {
                    color: '#26890d',
                    '&:hover': {
                        bgcolor: 'rgba(38, 137, 13, 0.04)'
                    }
                }
            }, /*#__PURE__*/ React.createElement(EditIcon, null)), isAuthorized('RBAC:DeletePolicy') && /*#__PURE__*/ React.createElement(IconButton, {
                onClick: function onClick() {
                    return handleDeletePolicy(policy);
                },
                sx: {
                    color: '#da291c',
                    '&:hover': {
                        bgcolor: 'rgba(218, 41, 28, 0.04)'
                    }
                }
            }, /*#__PURE__*/ React.createElement(DeleteIcon, null)))));
        });
    }())))), /*#__PURE__*/ React.createElement(PolicyModal, {
        open: policyModalOpen,
        onClose: function onClose() {
            setPolicyModalOpen(false);
            setSelectedPolicy(null);
        },
        onSave: handleSavePolicy,
        policy: convertToModalPolicy(selectedPolicy),
        loading: loading
    }), /*#__PURE__*/ React.createElement(ConfirmationDialog, {
        isOpen: deleteDialogOpen,
        setIsOpen: function setIsOpen() {
            setDeleteDialogOpen(false);
            setPolicyToDelete(null);
        },
        submitFunction: confirmDeletePolicy,
        title: "Delete Policy",
        bodyText: "Are you sure you want to delete the policy \"".concat(policyToDelete === null || policyToDelete === void 0 ? void 0 : policyToDelete.name, "\"? This action cannot be undone."),
        submitButtonText: "Delete",
        loading: loading
    }), /*#__PURE__*/ React.createElement(ConfirmationDialog, {
        isOpen: bulkDeleteDialogOpen,
        setIsOpen: function setIsOpen() {
            setBulkDeleteDialogOpen(false);
        },
        submitFunction: confirmBulkDelete,
        title: "Delete Policies",
        bodyText: "Are you sure you want to delete ".concat(selectedPolicies.length, " selected ").concat(selectedPolicies.length === 1 ? 'policy' : 'policies', "? This action cannot be undone."),
        submitButtonText: "Delete",
        loading: loading
    }));
};
export default PolicyManagement;
